import { render, staticRenderFns } from "./MapaIed.vue?vue&type=template&id=62235b02&scoped=true"
import script from "./MapaIed.vue?vue&type=script&lang=js"
export * from "./MapaIed.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=62235b02&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62235b02",
  null
  
)

export default component.exports